import React from "react";

import { Link, Typography } from "@mui/material";

import { ActionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";

import { PERISCOPE_USER_GUIDE_LINK } from "../../constants/index";
import GenericDialog from "./generic-dialog";
import {
  FeatureFlagActions,
  actionTypeToString,
} from "constants/periscope-actions";

interface DisplayErrorDialogProps {
  isDialogOpen: boolean;
  handleDialogClose: () => void;
  actionType: ActionType;
}

const DisplayErrorDialog = ({
  isDialogOpen,
  handleDialogClose,
  actionType,
}: DisplayErrorDialogProps) => {
  const isFeatureFlagAction = FeatureFlagActions.some(
    (action) => action.Value === actionType,
  );

  const actionName = actionTypeToString(actionType);

  return (
    <GenericDialog
      title="Unable to perform action"
      open={isDialogOpen}
      handleDialogClose={handleDialogClose}
      hasAckBtn={true}
    >
      <Typography variant="body2">
        You do not have permission to perform this action: {actionName}.{" "}
        {isFeatureFlagAction ? (
          "Reach out to product managers in the relevant product areas, who do have permission to toggle feature flags."
        ) : (
          <>
            For more details please see the{" "}
            <Link
              href={PERISCOPE_USER_GUIDE_LINK}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              Periscope user guide
            </Link>
            , or contact #business-systems on slack if you require further
            assistance.
          </>
        )}
      </Typography>
    </GenericDialog>
  );
};

export default DisplayErrorDialog;
